module.exports = __webpack_public_path__ + "static/media/expressLoad.97c74d89.svg";